<template>
  <div>
    <KanaStudy />
  </div>
</template>

<script setup>
import KanaStudy from '../components/KanaStudy.vue';
</script>

<style scoped>
/* Minimal wrapper styles */
</style>
